const rootActionPath = 'core/HeaderOnboardingCongratulations';

export const HEADER_ONBOARDING_CONGRATULATIONS_VIEW = `${rootActionPath}/VIEW`;
